import {
    Button,
    FormControl,
    FormControlLabel,
    Grid,
    Switch,
    TextField,
    Tooltip,
    Typography,
} from "@mui/material";
import { Box, Container, Stack } from "@mui/system";
import React, { useEffect, useState } from "react";
import SideBarMenuItems from "./SideBarMenuItems";
import {
    ConfirmTypes,
    SettingsMenuList,
    SideBarMenuNames,
} from "../core/Constants";
import Utils from "../core/Utils";
import NumericTextField from "./common/controls/NumericTextField";
import UserHelper from "../core/UserHelper";
import { useLocation, useNavigate } from "react-router-dom";
import MessagePopup from "./common/MessagePopUp";
import { VendorPage, LoginPage, AddNewVendorPage, ProductInvoicePage } from "../core/PageConstants";
import { useDispatch } from "react-redux";
import ConfirmPopup from "./common/ConfirmPopup";
import { connectToStore } from "../data/store";
import { postAsync } from "../core/serviceClient";
import Loader from "./common/Loader";
import { Regexes } from "../core/Regexes";
import InventoryMenuItems from "./InventoryMenuItems";
import CountryHelper from "../core/CountryHelper";
import { getCountry } from "../data/localSettingsActions";
import AddressField from "./common/controls/AddressField";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";

const AddNewInventory = () => {
    const [vendorName, setVendorName] = useState("");
    const [vendorDescription, setVendorDescription] = useState("");
    const [vendorAddress, setVendorAddress] = useState("");
    const [GSTNumber, setGSTNumber] = useState("");
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const [vendorContactNumber, setVendorContactNumber] = useState("");
    const [additionalContactNumber, setAdditionalContactNumber] = useState("");
    const [remark, setRemark] = useState("");
    const [active, setActive] = useState(true);
    const [msgOpen, setMsgOpen] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [selectedVendor, setselectedVendor] = useState(
        location.state && location.state.selectedVendor
            ? location.state.selectedVendor
            : {}
    );
    const [localSettings, setLocalSettings] = useState({});
    const [confirmFor, setConfirmFor] = useState("");
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [confirmText, setConfirmText] = useState("");
    const [isNavigateToLogin, setIsNavigateToLogin] = useState(false);
    const [isNavigateToInventory, setIsNavigateToInventory] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [addressISOCode, setAddressISOCode] = useState("");
    const [isOpenedCustomAddress, setIsOpenedCustomAddress] = useState(false);
    const [vendorCustomAddress, setVendorCustomAddress] = useState("");
    const [customerCity, setCustomerCity] = useState("");
    const [customerState, setCustomerState] = useState("");
    const [customerPincode, setCustomerPincode] = useState("");
    const [isUAEBusiness, setIsUAEBusiness] = useState(false);
    const [isFromProductIntake, setisFromProductIntake] = useState(false);

    useEffect(() => {
        let localSetting = connectToStore();
        if (UserHelper.CheckPermission(AddNewVendorPage, navigate, localSetting)) {
            setLocalSettings(localSetting);
            var countryInfo = getCountry();
            setAddressISOCode(countryInfo.ISOCode);
            setIsUAEBusiness(CountryHelper.IsBusinessCountryUAE());
            if (!Utils.IsNullOrEmpty(location.state)) {
                setisFromProductIntake(location.state.isfromProductIntake)
            }
        }
    }, []);

    useEffect(() => {
        populateInventory();
    }, [selectedVendor]);

    const populateInventory = () => {
        if (Utils.IsNullOrEmptyObject(selectedVendor)) {
            return;
        }
        setVendorName(selectedVendor.vendorName);
        setVendorDescription(selectedVendor.vendorDescription);
        setGSTNumber(selectedVendor.vendorGSTNumber);
        setVendorContactNumber(selectedVendor.vendorContact);
        setAdditionalContactNumber(selectedVendor.vendorAdditionalContact);
        if (!Utils.IsNullOrEmptyArray(selectedVendor.vendorAddress)) {
            setVendorAddress(selectedVendor.vendorAddress);
        } else {
            setIsOpenedCustomAddress(true);
            setVendorCustomAddress(selectedVendor.vendorCustomAddress);
            setCustomerCity(selectedVendor.vendorCustomCity);
            setCustomerState(selectedVendor.vendorCustomState);
            setCustomerPincode(selectedVendor.vendorCustomPinCode);
        }
        setRemark(selectedVendor.remark);
        setActive(selectedVendor.vendorStatus);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        let errorMsg = "";

        if (!Utils.IsNullOrEmpty(errorMsg)) {
            setMsgText(errorMsg);
            setMsgOpen(true);
        } else {
            if (!Utils.IsNullOrEmptyObject(selectedVendor)) {
                setConfirmFor("Update");
            } else {
                setConfirmFor("Submit");
            }
            setConfirmText("Are you sure you want to save changes?");
            setConfirmOpen(true);
        }
    };

    const handleMsgClose = () => {
        setMsgOpen(false);
        if (isNavigateToLogin) {
            UserHelper.LogOut(dispatch);
            navigate(LoginPage.Path);
        } else if (isNavigateToInventory) navigate(VendorPage.Path);
    };

    const handleConfirmClose = (value) => {
        setConfirmOpen(false);
        if (value == ConfirmTypes.OK) {
            if (confirmFor == "Submit") {
                SaveInventoryDetails();
            }
            if (confirmFor == "Update") {
                EditInventoryDetails();
            }
        }
    };

    async function SaveInventoryDetails() {
        setIsLoading(true);
        var vendorDetails = {
            BusinessId: JSON.parse(localStorage.getItem("business-entity")).id,
            VendorName: vendorName,
            VendorDescription: vendorDescription,
            VendorStatus: active,
            VendorAddress: isOpenedCustomAddress ? "" : vendorAddress,
            Remark: remark,
            VendorContact: Utils.IsNullOrEmpty(vendorContactNumber)
                ? 0
                : parseInt(vendorContactNumber),
            VendorAdditionalContact: Utils.IsNullOrEmpty(additionalContactNumber)
                ? ""
                : parseInt(additionalContactNumber),
            VendorGSTNumber: GSTNumber,
            VendorCustomAddress: isOpenedCustomAddress ? vendorCustomAddress : "",
            VendorCustomCity: isOpenedCustomAddress ? customerCity : "",
            VendorCustomState: isOpenedCustomAddress ? customerState : "",
            VendorCustomPinCode: isOpenedCustomAddress ? customerPincode : "",
        };
        let result2 = await postAsync(
            "Vendor/SaveVendorDetails",
            {
                BusinessId: localSettings.business.id,
                NewIsInventory: true,
                VendorInventory: vendorDetails,
            },
            "",
            "Execute",
            "",
            []
        );

        if (result2 && result2.data) {
            const selectedVendor = Array.isArray(result2?.data?.vendorDetails)
                ? result2.data.vendorDetails.find(
                    v => v.vendorContact === vendorContactNumber
                )
                : null;
            if (isFromProductIntake) {
                navigate(ProductInvoicePage.Path, {
                    state: {
                        selectedVendor: selectedVendor,
                        isfromVendorSetup: isFromProductIntake,
                        serviceitems: location.state.serviceItems,
                    }
                });
            } else {
                setIsNavigateToInventory(true);
            }
            setMsgText("Vendor Details Added Successfully");
            setMsgOpen(true);
        } else {
            setMsgText("Unable to process your request");
            setMsgOpen(true);
        }
        setIsLoading(false);
    }

    async function EditInventoryDetails() {
        setIsLoading(true);
        let ss = selectedVendor;
        ss["vendorName"] = vendorName;
        ss["vendorDescription"] = vendorDescription;
        ss["vendorAddress"] = isOpenedCustomAddress ? "" : vendorAddress;
        ss["vendorContact"] = Utils.IsNullOrEmpty(vendorContactNumber)
            ? 0
            : parseInt(vendorContactNumber);
        ss["vendorAdditionalContact"] = Utils.IsNullOrEmpty(additionalContactNumber)
            ? ""
            : parseInt(additionalContactNumber);
        ss["VendorCustomAddress"] = isOpenedCustomAddress
            ? vendorCustomAddress
            : "";
        ss["VendorCustomCity"] = isOpenedCustomAddress ? customerCity : "";
        ss["VendorCustomState"] = isOpenedCustomAddress ? customerState : "";
        ss["VendorCustomPinCode"] = isOpenedCustomAddress ? customerPincode : "";
        ss["VendorStatus"] = active;
        ss["GSTNumber"] = GSTNumber;
        ss["Remark"] = remark;
        let result2 = await postAsync(
            "Vendor/SaveVendorDetails",
            {
                BusinessId: localSettings.business.id,
                NewIsInventory: false,
                VendorInventory: ss,
            },
            "",
            "Execute",
            "",
            []
        );
        if (result2 && result2.data) {
            setIsNavigateToInventory(true);
            setMsgText("Changes Saved successfully");
            setMsgOpen(true);
        } else {
            setMsgText("Unable to process your request");
            setMsgOpen(true);
        }
        setIsLoading(false);
    }

    const isFormValid = () => {
        return (
            vendorName &&
            vendorDescription &&
            Utils.IsMobileValid(vendorContactNumber) &&
            (Utils.IsNullOrEmpty(GSTNumber) || Regexes.GST.test(GSTNumber)) &&
            ((isOpenedCustomAddress && !Utils.IsNullOrEmpty(customerCity)) ||
                (!isOpenedCustomAddress && !Utils.IsNullOrEmpty(vendorAddress)))
        );
    };

    const isError = !Utils.IsNullOrEmpty(GSTNumber) && GSTNumber.length !== 15;

    function toggleCustomAddress() {
        setIsOpenedCustomAddress((wasOpened) => !wasOpened);
    }
    const backNavigation = () => {
        if (isFromProductIntake) {
            navigate(ProductInvoicePage.Path, {
                state: {
                    isfromVendorSetup: isFromProductIntake,
                    serviceitems: location.state.serviceItems,
                    selectedVendor: location.state._selectedVendor
                }
            });
        }
    };

    return (
        <Container maxWidth="false" className="bg-color p-0">
            <Grid className="container">
                <Loader open={isLoading} />
                <MessagePopup
                    msgOpen={msgOpen}
                    msgText={msgText}
                    onMsgClose={handleMsgClose}
                />
                <ConfirmPopup
                    confirmOpen={confirmOpen}
                    confirmText={confirmText}
                    onConfirmClose={handleConfirmClose}
                />
                <Box>
                    <Grid container m={0}>
                        <SideBarMenuItems selectedTab={SideBarMenuNames.Inventory} />
                        <Grid xs={12} className="content-sec">
                            <Grid container direction="row" className="">
                                {!isFromProductIntake && (
                                    <InventoryMenuItems
                                        selectedMenu={SettingsMenuList.InventorySettings.VendorSetup}
                                    />
                                )}
                                <Grid flex="1" spacing={2} className="form-sec card white-bg">
                                    <form
                                        className="cs-form"
                                        style={{ paddingBottom: "30px" }}
                                        onSubmit={handleSubmit}
                                    >
                                        {isFromProductIntake && (
                                            <Tooltip title="Go Back">
                                                <Button onClick={backNavigation} className="back-btn">
                                                    <NavigateBeforeIcon />
                                                </Button>
                                            </Tooltip>
                                        )}
                                        <Stack sx={{ minWidth: 120 }} spacing={2} className="mt-3">
                                            <FormControl fullWidth>
                                                <TextField
                                                    inputProps={{ style: { fontSize: 13 } }}
                                                    label="Vendor Name "
                                                    type="text"
                                                    value={vendorName}
                                                    error={!vendorName}
                                                    onChange={(e) => setVendorName(e.target.value)}
                                                    placeholder="Enter Vendor Name"
                                                />
                                            </FormControl>
                                            <FormControl fullWidth>
                                                <TextField
                                                    inputProps={{ style: { fontSize: 13 } }}
                                                    label="Vendor Description "
                                                    type="text"
                                                    value={vendorDescription}
                                                    error={!vendorDescription}
                                                    onChange={(e) => setVendorDescription(e.target.value)}
                                                    placeholder="Enter Vendor Description"
                                                />
                                            </FormControl>
                                        </Stack>
                                        <Stack mt={2} spacing={2}>
                                            <Stack className="address-wrap">
                                                <Typography
                                                    component="label"
                                                    style={{ marginBottom: "10px" }}
                                                >
                                                    Address
                                                </Typography>
                                                {isOpenedCustomAddress ? (
                                                    <Grid>
                                                        <Stack
                                                            direction="row"
                                                            spacing={2}
                                                            className="justify-content-between mt-2"
                                                        >
                                                            <Typography component="label">
                                                                Use Custom Address
                                                            </Typography>
                                                            <Switch
                                                                checked={isOpenedCustomAddress}
                                                                edge="end"
                                                                onClick={toggleCustomAddress}
                                                            />
                                                        </Stack>
                                                        <FormControl fullWidth>
                                                            <TextField
                                                                id="vendorCustomAddress"
                                                                label="Address"
                                                                variant="outlined"
                                                                value={vendorCustomAddress}
                                                                onChange={(e) =>
                                                                    setVendorCustomAddress(e.target.value)
                                                                }
                                                                InputLabelProps={{ shrink: true }}
                                                            />
                                                        </FormControl>
                                                        <Stack
                                                            direction="row"
                                                            spacing={2}
                                                            className="m-t-2"
                                                        >
                                                            <FormControl fullWidth>
                                                                <TextField
                                                                    id="customerCity"
                                                                    label="City"
                                                                    variant="outlined"
                                                                    error={!customerCity}
                                                                    value={customerCity}
                                                                    onChange={(e) =>
                                                                        setCustomerCity(e.target.value)
                                                                    }
                                                                    InputLabelProps={{ shrink: true }}
                                                                />
                                                            </FormControl>
                                                            <FormControl fullWidth>
                                                                <TextField
                                                                    id="customerState"
                                                                    label={isUAEBusiness ? "Emirate" : "State"}
                                                                    variant="outlined"
                                                                    value={customerState}
                                                                    onChange={(e) =>
                                                                        setCustomerState(e.target.value)
                                                                    }
                                                                    InputLabelProps={{ shrink: true }}
                                                                />
                                                            </FormControl>
                                                            <FormControl fullWidth>
                                                                <TextField
                                                                    id="customerPincode"
                                                                    label="Pincode"
                                                                    variant="outlined"
                                                                    value={customerPincode}
                                                                    onChange={(e) =>
                                                                        setCustomerPincode(e.target.value)
                                                                    }
                                                                    InputLabelProps={{ shrink: true }}
                                                                />
                                                            </FormControl>
                                                        </Stack>
                                                    </Grid>
                                                ) : (
                                                    <>
                                                        {!Utils.IsNullOrEmpty(addressISOCode) && (
                                                            <AddressField
                                                                id="branchAddress"
                                                                variant="outlined"
                                                                label="Branch Address"
                                                                required
                                                                isValidate={true}
                                                                countryISoCode={addressISOCode}
                                                                value={vendorAddress}
                                                                setValue={setVendorAddress}
                                                            />
                                                        )}
                                                        <Stack
                                                            direction="row"
                                                            spacing={2}
                                                            className="justify-content-between mt-2"
                                                        >
                                                            <Typography component="label">
                                                                Use Custom Address
                                                            </Typography>
                                                            <Switch
                                                                checked={isOpenedCustomAddress}
                                                                edge="end"
                                                                onClick={toggleCustomAddress}
                                                            />
                                                        </Stack>
                                                    </>
                                                )}
                                            </Stack>

                                            {isUAEBusiness ? (
                                                <FormControl fullWidth className="my-xs-1">
                                                    <TextField
                                                        id="customerBusinessGSTIN"
                                                        label="Tax Id"
                                                        variant="outlined"
                                                        inputProps={{ maxLength: 15 }}
                                                        value={GSTNumber}
                                                        error={isError}
                                                        onChange={(e) => setGSTNumber(e.target.value)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </FormControl>
                                            ) : (
                                                <FormControl fullWidth>
                                                    <TextField
                                                        label="Vendor GST Number"
                                                        type="text"
                                                        value={GSTNumber}
                                                        error={
                                                            Utils.IsNullOrEmpty(GSTNumber)
                                                                ? false
                                                                : !Regexes.GST.test(GSTNumber)
                                                        }
                                                        onChange={(e) =>
                                                            setGSTNumber(e.target.value.toUpperCase())
                                                        }
                                                        placeholder="Enter Vendor GST Number"
                                                    />
                                                </FormControl>
                                            )}
                                            <Stack direction="row" mt={2} spacing={2}>
                                                <FormControl fullWidth>
                                                    <NumericTextField
                                                        value={vendorContactNumber}
                                                        setValue={setVendorContactNumber}
                                                        error={!Utils.IsMobileValid(vendorContactNumber)}
                                                        label="Contact Number"
                                                        inputProps={{
                                                            maxLength:
                                                                CountryHelper.GetMobileNumberMaxLength(),
                                                        }}
                                                        placeholder="Enter contact Number"
                                                    />
                                                </FormControl>
                                                <FormControl fullWidth>
                                                    <NumericTextField
                                                        value={additionalContactNumber}
                                                        setValue={setAdditionalContactNumber}
                                                        label="Additional Contact Number"
                                                        inputProps={{
                                                            maxLength:
                                                                CountryHelper.GetMobileNumberMaxLength(),
                                                        }}
                                                        placeholder="Enter Contact Number"
                                                    />
                                                </FormControl>
                                            </Stack>
                                            <Stack direction="row" mt={2} spacing={2}>
                                                <Stack
                                                    direction="row"
                                                    alignItems="center"
                                                    sx={{
                                                        border: "1px solid #cccccc",
                                                        borderRadius: "4px",
                                                        paddingX: 2,
                                                        paddingY: 1,
                                                    }}
                                                    className="font-size-14"
                                                >
                                                    <FormControl>
                                                        <FormControlLabel
                                                            control={
                                                                <Switch
                                                                    checked={active}
                                                                    onChange={(e) => setActive(e.target.checked)}
                                                                    name="Active"
                                                                    color="primary"
                                                                />
                                                            }
                                                            value={active}
                                                            label="Active"
                                                            labelPlacement="start"
                                                            sx={{ fontSize: "1rem" }}
                                                        />
                                                    </FormControl>
                                                </Stack>

                                                <FormControl fullWidth>
                                                    <TextField
                                                        label="Remarks"
                                                        type="text"
                                                        value={remark}
                                                        onChange={(e) => setRemark(e.target.value)}
                                                        placeholder="Enter Remarks"
                                                    />
                                                </FormControl>
                                            </Stack>
                                        </Stack>

                                        <br />
                                        {UserHelper.CanEdit() && (
                                            <Stack direction="row" className="fixed-btn">
                                                <Grid className="container" justifyContent="end">
                                                    <Stack direction="row" justifyContent="end">
                                                        <FormControl>
                                                            <Button
                                                                type="submit"
                                                                variant="contained"
                                                                className="btn btn-primary"
                                                                disabled={!isFormValid()}
                                                            >
                                                                Save
                                                            </Button>
                                                        </FormControl>
                                                    </Stack>
                                                </Grid>
                                            </Stack>
                                        )}
                                    </form>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </Grid>
        </Container>
    );
};

export default AddNewInventory;
